var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsIconAuto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.002,
    height: 33.594,
    viewBox: "0 0 29.002 33.594",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-32)",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.119,16.705h-4.9a1.075,1.075,0,0,1-1.077-1.077V8.823h-1.694a1.084,1.084,0,0,1-.847-1.737L151.824.409a1.081,1.081,0,0,1,1.694,0l5.219,6.676a1.083,1.083,0,0,1-.847,1.737H156.2v6.805A1.075,1.075,0,0,1,155.119,16.705Z",
    transform: "translate(-106.17 0)",
    fill: "#3a3630"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,156.289v12.2a1.083,1.083,0,0,0,.653.991l13.518,5.772a1.117,1.117,0,0,0,.847,0l13.338-5.772a1.077,1.077,0,0,0,.646-.991V156.469l-2.154,1.608v9.706l-11.177,4.839V162.334l12.635-4.81a1.086,1.086,0,0,0-.014-2.017L52.553,152.7l-.739,2.017,5.018,1.816-10.237,3.9-10.4-3.934,4.731-1.7-.725-2.024-7.487,2.685a1.088,1.088,0,0,0-.014,2.024",
    transform: "translate(0 -141.738)",
    fill: "#3a3630"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245,235.965l12.254-4.709-.144-11.055-12.017,4.063Z",
    transform: "translate(-197.709 -204.392)",
    fill: "#3a3630"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIconAuto);
export default __webpack_public_path__ + "static/media/settingsIcon_Auto.f0664f31581a5b585aa9f7b6d9ec6835.svg";
export { ForwardRef as ReactComponent };